import { useState } from "react";

// css
import "./FloatingButton.css";

// config
import colors from "../../../config/colors";
import { isString } from "../../../Utilities/utils";
import { FaCheck, FaCopy } from "react-icons/fa";

// components

function CopyTextButton({ 
    bottom = "8%",
    width = 35,
    height = 35,
    borderRadius = 35,
    right = 15,
    actionTitle = 'Copy',
    copyTooltipTop = -40,
    transform = "translateX(-70%)",
    copyText,
    successMessage = "Copied Class Id."
}) {
  const [copied, setCopied] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [toolTipMsg, setToolTipMsg] = useState(actionTitle)


  const copyClassIdAction = async() => {
    try {
        if (!isString(copyText)) {
            return;
        }
      await navigator.clipboard.writeText(copyText);

      setToolTipMsg(successMessage);
      setCopied(true);
      setShowTooltip(true);

      // Change back to copy icon after 2 seconds
      setTimeout(() => {
        setToolTipMsg(actionTitle);
        setCopied(false);
        setShowTooltip(false);
      }, 2000);
    } catch (error) {
        setCopied(true);
        setToolTipMsg("Failed to copy text.")
    }
  }

  return (
    <div className="floating-button-wrapper" style={{ bottom, right }}>
      {
        showTooltip && (
            <div className="copy-tooltip-box" style={{ top: copyTooltipTop, transform }}>
                <div className="copy-tooltip">
                    { toolTipMsg && <span>{toolTipMsg}</span> }
                </div>
            </div>
        )
      }
      <div
        className="floating-button-box"
        style={{
          width,
          height,
          borderRadius,
          backgroundColor: copied ? colors.success : colors.primary,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
          bottom,
          right,
          cursor: "pointer",
          opacity: copied ? 0.6 : 1,
          transform: "0.2s",
        }}
        onMouseEnter={() => {
            if (!copied) setShowTooltip(true);
        }}
        onMouseLeave={() => {
            if (!copied) setShowTooltip(false);
        }}
        onClick={() => copyClassIdAction()}
      >
        {
          copied ? <FaCheck color={colors.white} /> : <FaCopy color={colors.white} />
        }
      </div>
    </div>
  );
}

export default CopyTextButton;
